import { useEffect, useState, type ComponentType } from "react";

type ProjectXSyncComponent = ComponentType<Record<string, never>>;

export function LazyProjectXSyncProvider() {
  const [Provider, setProvider] = useState<ProjectXSyncComponent | null>(null);

  useEffect(() => {
    let cancelled = false;
    let timeoutId: number | null = null;

    const loadProvider = () => {
      timeoutId = window.setTimeout(() => {
        import("./ProjectXSyncProvider").then((module) => {
          if (cancelled) return;
          setProvider(() => module.ProjectXSyncProvider);
        });
      }, 0);
    };

    if (document.readyState === "complete") loadProvider();
    else window.addEventListener("load", loadProvider, { once: true });

    return () => {
      cancelled = true;
      if (timeoutId !== null) window.clearTimeout(timeoutId);
      window.removeEventListener("load", loadProvider);
    };
  }, []);

  if (!Provider) return null;
  return <Provider />;
}
